import React from 'react';

export default function AnalyticsCard({ icon: Icon, label, value, hint, loading, accent = 'lime' }) {
  const accentClass =
    accent === 'purple'
      ? 'text-gray-300 bg-white/[0.06] border-white/[0.12]'
      : 'text-[#B0FC38] bg-[#B0FC38]/[0.08] border-[#B0FC38]/20';

  return (
    <div className="relative p-6 rounded-2xl bg-white/[0.025] border border-white/[0.06] backdrop-blur-sm overflow-hidden">
      <div className="flex items-start justify-between mb-5">
        <div className="text-[11px] font-medium text-gray-500 tracking-wider uppercase">{label}</div>
        {Icon && (
          <div className={`w-8 h-8 rounded-lg border flex items-center justify-center ${accentClass}`}>
            <Icon className="w-4 h-4" />
          </div>
        )}
      </div>
      <div className="flex items-baseline gap-2">
        {loading ? (
          <div className="w-24 h-8 rounded bg-white/[0.04] animate-pulse" />
        ) : (
          <div className="text-[2rem] leading-none font-semibold text-white tracking-tight tabular-nums">
            {value}
          </div>
        )}
      </div>
      {hint && !loading && (
        <div className="mt-2 text-[12px] text-gray-500 truncate" title={hint}>
          {hint}
        </div>
      )}
    </div>
  );
}
